import { FordeerApp } from '@fordeer/ui-components'
import { createPostHogErrorTracking } from '@fordeer/posthog-error-tracking'
import { POSTHOG_API_KEY } from '@constant/featureFlags'
import posthog from 'posthog-js'

export const postHogErrorTracking = createPostHogErrorTracking(posthog, {
  appName: FordeerApp.Invoice,
  environment: import.meta.env.MODE,
  enabled: Boolean(POSTHOG_API_KEY),
})
